export const getMarketFromPath = (): string => {
	const path = window.location.pathname;

	// Regular expression to check for 3-letter country code at the root level
	const match = path.match(/^\/([a-z]{3})(\/|$)/);
	return match ? match[1] : "";
};
